/** Glow-infused shadows with teal tint */
export const glowShadows = {
  sm: '0 1px 3px rgba(30, 190, 200, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px rgba(30, 190, 200, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px rgba(30, 190, 200, 0.12), 0 4px 6px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px rgba(30, 190, 200, 0.15), 0 8px 10px rgba(0, 0, 0, 0.04)',
  hoverGlow: '0 8px 25px rgba(30, 190, 200, 0.25)',
  focusGlow: '0 0 0 3px rgba(30, 190, 200, 0.35)',
  cardGlow: '0 4px 20px rgba(30, 190, 200, 0.12)',
} as const;
